module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modalcon"
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    ref: "modalContainer",
    staticClass: "modal-container",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "keydown": _vm.handleKeydown
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('button', {
    staticClass: "btn closebtn",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('carousel', {
    ref: "magnifyCarosel",
    staticClass: "magnifyimg zoom-carousel",
    attrs: {
      "perPage": 1,
      "navigationEnabled": true,
      "paginationEnabled": false,
      "autoplay": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "speed": 0
    }
  }, _vm._l((_vm.imgslide), function(img, index) {
    return _c('slide', {
      key: index
    }, [(img.includes('%video%')) ? _c('VideoPlayer', {
      attrs: {
        "src": img.split('%video%')[0],
        "poster": img.split('%video%')[1],
        "playVideo": true
      }
    }) : _c('div', [(_vm.isDesktop) ? _c('div', {
      on: {
        "mousemove": _vm.mouseMove
      }
    }, [_c('img', {
      class: {
        'disNone': _vm.showZoom
      },
      staticStyle: {
        "cursor": "zoom-in"
      },
      attrs: {
        "data-src": _vm.prodImgPath + img,
        "alt": img
      }
    }), _vm._v(" "), _c('zoom-on-hover', {
      class: {
        'disNone': !_vm.showZoom
      },
      staticStyle: {
        "cursor": "zoom-in"
      },
      attrs: {
        "img-normal": _vm.prodImgPath + img,
        "scale": 2
      }
    })], 1) : _c('div', {
      staticClass: "zoom-mobile"
    }, [_c('zoom-on-hover', {
      staticStyle: {
        "cursor": "zoom-in"
      },
      attrs: {
        "img-normal": _vm.prodImgPath + img,
        "scale": 2
      }
    })], 1)])], 1)
  }))], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e883d2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/productView.vue
// module id = 2520
// module chunks = 14